<template>
  <!-- Header -->
  <div class="relative bg-bgbb-y md:pt-10 pb-32">
    <div class="px-2 md:px-4 mx-auto w-full">
      <div>
        <!-- Card stats -->
        <div class="flex flex-wrap">
          <div class="w-full lg:w-12/12 xl:w-10/12 px-4">
         
         
<br><br>
 <div class="text-white px-6 py-4 border-0 rounded relative bg-red-500 shadow-2xl">
  <span class="text-xl inline-block mr-5 align-middle">
    <i class="fas fa-bell mr-2"></i>
  </span>
  <span class="inline-block align-middle mr-8">
   
   BGBB Will Launch in Q3 2021.
  </span>

</div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import CardStats from "@/components/Cards/CardStats.vue";

export default {
  components: {
   // CardStats,
  },
};
</script>
